export default {
  title: {
    historyList: "历史列表",
    keySteps: "关键步骤",
  },
  buttons: {
    historyList: "历史列表",
    keySteps: "关键步骤",
  },
};
